import {
  CreateClientRequest,
  CreateClientResponse,
  SignInRequest,
  SignInResponse,
} from './auth.types'
import axios from '../base'
import { SignUpRequest, SignUpResponse } from '.'
import { handleError } from 'utils/error'

export class AuthService {
  signIn = async (fields: SignInRequest): Promise<SignInResponse> => {
    const { data } = await axios.post<SignInResponse>('login', fields)
    if (data.error) {
      handleError(
        data.description
          ? Error(data.description)
          : Error("We didn't recognize your credentials. Please try again.")
      )
      return {} as SignInResponse
    } else {
      return data
    }
  }
  signUp = async (fields: SignUpRequest): Promise<SignUpResponse> => {
    const { data } = await axios.post<SignUpResponse>('signup', {
      first_name: fields.firstName,
      last_name: fields.lastName,
      email: fields.email,
      password: fields.password,
    })
    if (data.error) {
      handleError(
        data.description
          ? Error(data.description)
          : Error('Error on signUp. Please try again.')
      )
      return {} as SignUpResponse
    } else {
      return data
    }
  }
  createClient = async (
    fields: CreateClientRequest
  ): Promise<CreateClientResponse> => {
    const { data } = await axios.post<CreateClientResponse>('signup', fields)
    if (data.error) {
      handleError(
        data.description
          ? Error(data.description)
          : Error('Error on signUp. Please try again.')
      )
      return {} as CreateClientResponse
    } else {
      return data
    }
  }
  resetPassword = async (fields: {
    userId: string
    locationId?: string
    email?: string
  }): Promise<CreateClientResponse> => {
    const { userId, locationId, email } = fields
    const base = locationId
      ? `/users/${userId}/reset-password/${locationId}`
      : `/users/${userId}/reset-password`
    const url = email
      ? `${base}?email=${encodeURIComponent(email)}`
      : base
    const { data } = await axios.post<CreateClientResponse>(url)
    return data
  }
  resetPasswordWithToken = async (fields: {
    token: string
    password: string
  }): Promise<{ error: boolean; description?: string }> => {
    const { token, password } = fields
    // Backend route is POST /api/v1/users/update/reset-password and it reads the
    // token + new password from a nested `password_data` object
    // (users/api.py:434 -> user_class.py update(password_data=...)). The old
    // '/reset-password' path + flat {token,password} body 404'd, so no reset ever
    // completed the set-password step (product#499).
    const { data } = await axios.post<{
      error: boolean
      description?: string
    }>('/users/update/reset-password', {
      password_data: { reset_password_token: token, password },
    })
    if (data.error) {
      handleError(
        data.description
          ? Error(data.description)
          : Error('Could not reset password. The link may have expired.')
      )
    }
    return data
  }
}

export default new AuthService()
